<div class="wrap">
  <div class="header" id="header_home">
    <div class="header_title" [ngClass]="{'header_title_mobile': isMobile}">

      <div class="left-text" [innerHTML]="topLeftText" *ngIf="!isMobile"></div>

      <ul class="nav" *ngIf="!isMobile">
        <li *ngFor="let m of mainMenu" class="nav_item" (click)="getRouteNavigate(m.url)"
          [ngClass]="{active: ifRouteActive(m?.url)}">{{m.name}} <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="m.url === '/home'">
          </fa-icon>
        </li>
      </ul>

      <h1 *ngIf="titleHomePage !== 'Trouver un article' && !isMobile">{{titleHomePage}}</h1>
      <ng-container *ngIf="isMobile; else noMobileTemplate">
        <div class="search_activity" (click)="openSearchDiv()" >
          <fa-icon [icon]="getFaIcon('faSearch')" appChangeColorTheme attribute="bgc" ></fa-icon>
        </div>

        <div class="images" #scrollContainer (mouseenter)="pauseScroll()" (mouseleave)="resumeScroll()" (touchstart)="pauseScroll()" (touchend)="resumeScroll()" (touchcancel)="resumeScroll()">
          <ng-container *ngIf="notices.length > 1; else elseTemplate">
            <ng-container *ngFor="let notice of notices">
              <div class="name-image" (click)="seeDetails(notice)" [innerHTML]="notice?.thumbImage"></div>
            </ng-container>
            <!-- Duplication for infinite scroll effect -->
            <ng-container *ngFor="let notice of notices">
              <div class="name-image" (click)="seeDetails(notice)" [innerHTML]="notice?.thumbImage"></div>
            </ng-container>
            <!-- Duplication for infinite scroll effect -->
            <ng-container *ngFor="let notice of notices">
              <div class="name-image" (click)="seeDetails(notice)" [innerHTML]="notice?.thumbImage"></div>
            </ng-container>
          </ng-container>

          <ng-template #elseTemplate>
            <ng-container *ngFor="let notice of notices">
              <div class="name-image" (click)="seeDetails(notice)" [innerHTML]="notice?.thumbImage"></div>
            </ng-container>
          </ng-template>
        </div>
      </ng-container>
      <ng-template #noMobileTemplate>
        <div class="search_activity" *ngIf="titleHomePage === 'Trouver un article'" (click)="openSearchDiv()" >
          <span>Trouver un article</span>
          <fa-icon [icon]="getFaIcon('faSearch')" appChangeColorTheme attribute="bgc" ></fa-icon>
        </div>
      </ng-template>

      <div class="right-text" [innerHTML]="topRightText" *ngIf="!isMobile"></div>
    </div>
    <div class="shadow"></div>
  </div>
</div>
